// extracted by mini-css-extract-plugin
module.exports =  {"btn":"mTBRWF_","icon":"Dv4Gkfw","open":"xZgv5C8"};